export default __webpack_public_path__ + "164f73e1b3b8838ef6a22378d277d60e.png";